import { useRef, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const TinyMCEEditor = ({ onEditorChange, initialValue }) => {
  
  const editorRef = useRef(null);
  const placeholder = 'Type the question here..'

  useEffect(() => {
    if (editorRef.current) {
      const currentContent = editorRef.current.getContent();
      if (currentContent !== initialValue) {
        editorRef.current.setContent(initialValue || '');
      }
    }
  }, [initialValue]);

  const handleEditorChange = (content, editor) => {
    onEditorChange(content);
  };

  const init = {
    placeholder,
    plugins: [
              'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
              'insertdatetime','table', 'wordcount','emoticons','codesample'
              ],
    toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
    branding: false,
    promotion: false,
    elementpath: false
  };

  return (
    <Editor
      initialValue={initialValue}
      init={init}
      onEditorChange={handleEditorChange}
      onInit={(evt, editor) => {
        editorRef.current = editor;
      }}
    />
  );
};
export default TinyMCEEditor;

